import { render, staticRenderFns } from "./transaction-row.vue?vue&type=template&id=e55a922a&scoped=true"
import script from "./transaction-row.vue?vue&type=script&lang=js"
export * from "./transaction-row.vue?vue&type=script&lang=js"
import style0 from "./transaction-row.vue?vue&type=style&index=0&id=e55a922a&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e55a922a",
  null
  
)

export default component.exports